import { GenerateCodeStudentType, StudentClassType, StudentDocumentType, StudentType } from "../../../types/Student";
import { StudentSubjectGradeType } from "../../../types/StudentSubjectGrade";
import { get, post, postBlob, put } from "../../../utils/axios-config";
import { GENERATE_PRINT_DOCUMENT, STUDENT_CERTIFICATES, STUDENT_CLASSES, STUDENT_DOCUMENTS, STUDENT_SUBJECTS_GRADE, STUDENTS, STUDENTS_CREATE_CODE, STUDENTS_SYNC } from "../../../utils/constants";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";

export const createStudent = async (data: StudentType) => await post<StudentType, string>(STUDENTS, data);
export const updateStudent = async (data: StudentType) => await put<StudentType, string>(STUDENTS, data);

export const createStudentCode = async (data: GenerateCodeStudentType) => await post<GenerateCodeStudentType, string>(STUDENTS_CREATE_CODE, data);

export const createStudentClass = async (data: StudentClassType) => await post<StudentClassType, string>(STUDENT_CLASSES, data);

export const createStudentDocument = async (data: StudentDocumentType) => await post<StudentDocumentType, string>(STUDENT_DOCUMENTS, data);
export const updateStudentDocument = async (data: StudentDocumentType) => await put<StudentDocumentType, string>(STUDENT_DOCUMENTS, data);



//export const createExportedDocument = async (data: any) => await post<any, any>(GENERATE_PRINT_DOCUMENT, data);
export const createExportedDocument = async (data: any): Promise<Blob> => {
  return await postBlob<any>(GENERATE_PRINT_DOCUMENT, data);
};
export const createStudentSubjectGrade = async (data: StudentSubjectGradeType) => await post<StudentSubjectGradeType, string>(STUDENT_SUBJECTS_GRADE, data);
export const getStudentSubjectGrade = async (data: PagedRequestType) => {

    const queryParams = new URLSearchParams(
        Object.entries(data)
            .filter(([_, value]) => value !== undefined && value !== "")
            .reduce((acc, [key, value]) => {
                acc[key] = typeof value === "boolean" ? (value ? "1" : "0") : value.toString();
                return acc;
            }, {} as Record<string, string>)
    );
    return await get<PagedResultsType<StudentSubjectGradeType>>(`${STUDENT_SUBJECTS_GRADE}?${queryParams.toString()}`);
};
export const updateStudentSubjectGrade = async (data: StudentSubjectGradeType) => await put<StudentSubjectGradeType, string>(STUDENT_SUBJECTS_GRADE, data);

export const syncStudent = async (data: any) => await post<any, boolean>(STUDENTS_SYNC, data);

export const createStudentCertificate = async (data:any) => {
      return await post<any,any>(STUDENT_CERTIFICATES, data);
};